import React from 'react'
import Immutable from 'immutable'
import {
  FlexDirection,
  Space,
  Box,
  Checkbox,
  Color,
  Display,
  Text,
} from '@gousto-internal/citrus-react'
import { Motivations } from '@library/api-motivations/src/types'

export type SignupMotivationsSelectorProps = {
  hasSignupMotivations: boolean
  onHasSignupMotivationsChange: (value: boolean) => void
  signupMotivations: Immutable.List<string>
  onSignupMotivationsChange: (id: string) => void
  motivations: Motivations[]
}

export function SignupMotivationsSelector({
  signupMotivations,
  onSignupMotivationsChange,
  motivations,
}: SignupMotivationsSelectorProps) {
  return (
    <Box>
      <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
        {motivations.map(({ id, title }) => {
          const checked = signupMotivations.includes(id)
          const maxSelection = 3
          const disabled = !checked && signupMotivations.size >= maxSelection

          return (
            <React.Fragment key={id}>
              <Checkbox
                key={id}
                id={id}
                checked={checked}
                disabled={disabled}
                onChange={() => onSignupMotivationsChange(id)}
                paddingH={4}
                paddingV={4}
                data-testid={`signup-motivation-${id}`}
                outline={true}
              >
                {(focused) => (
                  <Box display={Display.Flex}>
                    <Space size={2} direction="horizontal" />
                    <Text
                      style={{
                        transform: 'translateY(-2px)',
                        fontWeight: checked ? 'bold' : 'normal',
                      }}
                      display={Display.Flex}
                      size={4}
                      color={focused || checked ? Color.Secondary_400 : Color.ColdGrey_800}
                    >
                      {title}
                    </Text>
                  </Box>
                )}
              </Checkbox>
              <Space size={2} />
            </React.Fragment>
          )
        })}
      </Box>
    </Box>
  )
}
